/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import type { ComponentAttrs } from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import type Mithril from 'mithril';

export default class HomeWelcome extends Component {
	oncreate(vnode: Mithril.VnodeDOM<ComponentAttrs, this>) {
		super.oncreate(vnode);

		this.$('a').on('click', (e) => {
			if (e.ctrlKey || e.metaKey || e.which === 2) return;
			e.preventDefault();
			m.route.set((e.currentTarget as HTMLAnchorElement).href);
		});
	}

	view() {
		return <div className="HomeWelcome">{this.items().toArray()}</div>;
	}

	items(): ItemList<Mithril.Children> {
		const items = new ItemList<Mithril.Children>();

		// Add the welcome title and message
		items.add('welcome-title', <h1>{m.trust(app.forum.attribute<string>('welcomeTitle'))}</h1>);

		// Add the welcome message
		items.add('welcome-message', <div className="HomeWelcome-subtitle">{m.trust(app.forum.attribute<string>('welcomeMessage'))}</div>);

		return items;
	}
}
